import { TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

import { EDealType, EOfferType, TPageType } from 'shared/types/features';

import * as styles from './styles.css';

type TGuideStartBlockPageType = Extract<TPageType, 'sob' | 'host'>;

interface IGuideStartBlockProps {
  title: string;
  description: string;
  device: TDeviceType;
  pageType: TGuideStartBlockPageType;
  dealType?: EDealType;
  offerType: EOfferType;
}

export const GuideStartBlock: React.FC<IGuideStartBlockProps> = ({
  title,
  description,
  device,
  pageType,
  dealType,
  offerType,
}) => {
  return (
    <div
      className={clsx(
        styles['container'],
        styles[device],
        styles[pageType],
        dealType && styles[dealType],
        styles[offerType],
      )}
    >
      <div className={styles['wrapper']}>
        <h1 className={styles['textblock']}>
          <span className={styles['title']}>{title}</span>
          <span className={styles['description']}>{description}</span>
        </h1>
        <div className={styles['image']} role="img" aria-label={title} />
      </div>
    </div>
  );
};
